'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

stickyReceiptDirective.$inject = ['$window', '$timeout'];


var _ = {
    throttle: _throttle3.default,
    debounce: _debounce3.default
};

var _module = _angular2.default.module('cb.ui-components.sticky', []);

_module.directive('cbStickyReceipt', stickyReceiptDirective);

exports.default = _module;


function stickyReceiptDirective($window, $timeout) {
    return {
        scope: true,
        link: StickyReceiptLink,
        priority: 1 // without this, ng-class on the element won't work
    };

    function StickyReceiptLink(scope, element, attrs, ctrl) {

        //console.log($(element).position());
        var cbStickyReceiptRequested = false;
        var waitForOffsetCalculation = void 0;
        var originalOffsetTop = void 0;
        var windowWidth = $(window).width();
        var jqElement = $(element);
        var receiptWidth = jqElement.width();
        var receiptBanner = jqElement.find('div[class*=receipt__image-wrapper]');
        var aside = jqElement.parent('aside[class*="js-receipt-aside"]');
        var receiptScrollDistance = void 0;
        var receiptBannerScrollDistance = void 0;
        var asideScrollDistance = void 0;
        var receiptFloatToBottom = false;

        activate();

        function activate() {
            //timeout because it takes time for Angular SPA files to load and position should be calculated after page is fully loaded
            $timeout(function () {
                // set originalOffsetTop to the offset top from the receipt on opening of the page
                originalOffsetTop = $(element).offset().top;
                receiptBanner = jqElement.find('div[class*=receipt__image-wrapper]');
                setDistances();
                requestCbStickyReceipt();
            }, 750);

            $(window).on('scroll', _.throttle(function (e) {
                setDistances();
                requestCbStickyReceipt();
            }, 100));

            $(window).on('resize', _.debounce(function () {
                if (window.innerWidth !== windowWidth) {
                    windowWidth = window.innerWidth;
                    resetStickyReceipt();
                }
            }, 100));

            $(window).on('orientationchange', function () {
                resetStickyReceipt();
            });

            window.addEventListener('resetStickyReceipt', function (e) {
                resetStickyReceipt();
            }, false);

            function setDistances() {
                receiptScrollDistance = aside.length ? window.pageYOffset + element.height() + element.find('.receipt__header').height() : null;
                receiptBannerScrollDistance = receiptBanner.length ? receiptScrollDistance + receiptBanner.height() : null;
                asideScrollDistance = aside.length ? aside.height() + originalOffsetTop : null;
            }

            function resetStickyReceipt() {
                $window.requestAnimationFrame(function () {
                    element[0].classList.remove('receipt--sticked-to-bottom');
                    element[0].classList.remove('receipt--sticked-to-top');
                    element[0].classList.remove('receipt--float-to-bottom');
                    receiptFloatToBottom = false;
                    $(element).css('width', '');

                    if (receiptBanner.length) {
                        receiptBanner[0].classList.remove('receipt__image-wrapper-hide');
                    }

                    waitForOffsetCalculation = true; //set a variable to prevent readding the class in cbStickyReceipt while timeout that calculates offset is not completed
                    $timeout(function () {
                        originalOffsetTop = jqElement.offset().top;
                        receiptWidth = jqElement.width();
                        setDistances();
                        waitForOffsetCalculation = false;
                        requestCbStickyReceipt();
                    });
                });
            }
        }

        // explanation about requestcbStickyReceipt https://www.html5rocks.com/en/tutorials/speed/animations/
        function requestCbStickyReceipt() {
            if (!cbStickyReceiptRequested) {
                requestAnimationFrame(setStickyReceipt);
                cbStickyReceiptRequested = true;
            }
        }

        function setStickyReceipt() {
            if (!waitForOffsetCalculation) {
                //if receipt scroll distance is higher than aside length (+ offset) set the receipt to float to bottom
                if (aside.length) {
                    if (window.innerWidth > attrs.cbStickyReceipt && receiptScrollDistance >= asideScrollDistance) {
                        element[0].classList.add('receipt--float-to-bottom');
                        receiptFloatToBottom = true;
                    } else {
                        element[0].classList.remove('receipt--float-to-bottom');
                        receiptFloatToBottom = false;
                    };
                }

                //if receipt scroll distance (with banner) is higher than aside length (+ offset) set the receipt to float to bottom
                if (receiptBanner.length) {
                    if (receiptBannerScrollDistance >= asideScrollDistance) {
                        receiptBanner[0].classList.add('receipt__image-wrapper-hide');
                    } else {
                        receiptBanner[0].classList.remove('receipt__image-wrapper-hide');
                    };
                }

                // if scroll position + screen height is smaller then the original offset top of the receipt (at the bottom of the screen) set the receipt to sticky
                if (window.innerWidth < attrs.cbStickyReceipt) {
                    if (window.pageYOffset + $(window).height() - 100 < originalOffsetTop) {
                        element[0].classList.add('receipt--sticked-to-bottom');
                    } else {
                        element[0].classList.remove('receipt--sticked-to-bottom');
                    }
                } else {
                    if (window.pageYOffset + 40 > originalOffsetTop && !receiptFloatToBottom) {
                        element[0].classList.add('receipt--sticked-to-top');
                    } else {
                        element[0].classList.remove('receipt--sticked-to-top');
                    }
                    if (window.pageYOffset + 40 > originalOffsetTop) {
                        $(element).css('width', receiptWidth);
                    } else {
                        $(element).css('width', '');
                    }
                };
            }

            cbStickyReceiptRequested = false;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-sticky-receipt.directive.js
// module id = 862
// module chunks = 0